import React, { useState, useEffect, useRef } from 'react'
import { axios } from '../../axios'
import { Link } from "react-router-dom"
import M from 'materialize-css'
import ImageNotAvailable from './img/not-available.png'

/**
  * Vista espejo de theme-001 Admin (pages/catalogo/index.jsx), 3 nov 2026.
  * Diferencias a propósito: sin toggle "On marketplace" (sellers solo usa
  * "Visible"), sin link a comentarios (sellers no tiene esa ruta) y la capa
  * de datos es axios directo — cuando sellers suba de React y entre a
  * @package/hooks solo cambia esa capa (useFetchSellerCatalogo, useSellerPapelera,
  * useResellerOrders, useUpdateStock), no la vista.
  */

const Paginacion = ({ pagina, totalPaginas, onChange, perPage, onPerPageChange }) => {
	if (totalPaginas <= 1 && !onPerPageChange) return null
	return (
		<div style={{ display: 'flex', alignItems: 'center', width: '100%', minHeight: 50 }}>
			<div style={{ flex: 1 }} />
			{totalPaginas > 1 && (
				<ul className="pagination center-align" style={{ margin: 0 }}>
					<li className={pagina === 1 ? 'disabled' : 'waves-effect'}>
						<a href="#!" onClick={(e) => { e.preventDefault(); if (pagina > 1) onChange(pagina - 1) }}>
							<i className="material-icons">chevron_left</i>
						</a>
					</li>
					{Array.from({ length: totalPaginas }, (_, i) => i + 1).map((n) => (
						<li key={n} className={n === pagina ? 'active black' : 'waves-effect'}>
							<a href="#!" className={n === pagina ? 'white-text' : 'black-text'} onClick={(e) => { e.preventDefault(); onChange(n) }}>
								{n}
							</a>
						</li>
					))}
					<li className={pagina === totalPaginas ? 'disabled' : 'waves-effect'}>
						<a href="#!" onClick={(e) => { e.preventDefault(); if (pagina < totalPaginas) onChange(pagina + 1) }}>
							<i className="material-icons">chevron_right</i>
						</a>
					</li>
				</ul>
			)}
			<div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8 }}>
				{onPerPageChange && (
					<>
						<span style={{ whiteSpace: 'nowrap' }}>Products per page</span>
						<select className="browser-default" style={{ width: 'auto', display: 'inline-block' }} value={perPage} onChange={(e) => onPerPageChange(Number(e.target.value))}>
							{[10, 25, 50, 100].map((n) => (
								<option key={n} value={n}>{n}</option>
							))}
						</select>
					</>
				)}
			</div>
		</div>
	)
}

const Catalogo = () => {
	const [view, setSwich] = useState(false)
	const [catalogo, setCatalogo] = useState([])
	const [papelera, setPapelera] = useState([])
	const [search, setSearch] = useState('')
	const [searchArchivados, setSearchArchivados] = useState('')
	const [page, setPage] = useState(1)
	const [lastPage, setLastPage] = useState(1)
	const [perPage, setPerPage] = useState(50)
	const firstLoad = useRef(true)

	// estados para el funcionamiento add_stock y historial de stock
	const [orderHistory, setOrderHistory] = useState([])
	const [productoStockSelect, setProductoStockSelect] = useState({})                 // producto elegido en el modal
	const [formDataStockAdd, setFormDataStockAdd] = useState({ folio:'', item_no:'', quantity:'', note:'' })

	/**
	  * Carga paginada del catálogo. Con ?page el backend (General\CatalogoController::index)
	  * responde {data, current_page, last_page, total}; search filtra en servidor.
	  * La unidad de la página es la VARIANTE (decisión de Erik, ago 2026).
	  */
	const _fetchCatalogo = (p, s = search, pp = perPage) => {
		axios.get('/api/seller/catalogo', { params: { page: p, per_page: pp, ...(s !== '' ? { search: s } : {}) } })
		.then(r => {
			setCatalogo(r.data.data)
			setPage(r.data.current_page)
			setLastPage(r.data.last_page)
		})
		.catch(r => alert(r))
	}

	// cambiar productos por página siempre regresa a la página 1
	const _changePerPage = (pp) => {
		setPerPage(pp)
		_fetchCatalogo(1, search, pp)
	}

	useEffect(()=>{
		axios.get('/api/seller/catalogo', { params: { page: 1, per_page: perPage } })
		.then(r=>{
			setCatalogo(r.data.data)
			setPage(r.data.current_page)
			setLastPage(r.data.last_page)
			M.Tabs.init(document.querySelectorAll('.tabs'),{})
		})
		.catch(r=>alert(r))

		axios.get('/api/seller/getPapelera')
		.then(r=>{
			setPapelera(r.data)
			M.Tooltip.init(document.querySelectorAll('.tooltipped'),{})
		})
		.catch(r=>alert(r))

		// historial de stock añadido
		axios.get('/api/seller/get_my_orders').then(r => setOrderHistory(r.data)).catch(r => alert(r))

		M.Modal.init(document.querySelectorAll('.modal'), {})
	},[])

	// búsqueda server-side con debounce; siempre regresa a la página 1
	useEffect(() => {
		if (firstLoad.current) {
			firstLoad.current = false
			return
		}
		const timer = setTimeout(() => _fetchCatalogo(1, search), 400)
		return () => clearTimeout(timer)
	}, [search])

	// el modal de stock monta su datepicker/select cuando cambia el producto elegido
	useEffect(() => {
		setFormDataStockAdd({ folio:'', item_no:'', quantity:'', note:'' })
		setTimeout(() => {
			M.FormSelect.init(document.querySelectorAll('select'), {})
			M.Datepicker.init(document.querySelectorAll('.datepicker'), { format: 'yyyy-mm-dd' })
		}, 0)
	}, [productoStockSelect])

	const _changeView = () =>{
		setSwich(!view)
	}

	const _restaurar = (id) =>{
		axios.put(`/api/seller/updatePapelera/${id}`)
		.then((r) => {
			M.toast({html: 'Producto Restaurado'})
			setPapelera(papelera.filter(p =>p.id !==id))
			_fetchCatalogo(page)
		})
		.catch(r=>alert(r))
	}

	/*
	   *
	   * Catalogo obj
	   */
	const _updateCatalogo = (obj,checked) =>{
		const newCatalogo = catalogo.map(c=>c.id===obj.id?{...obj,visible:checked}:c)
		setCatalogo(newCatalogo)
		axios.post('/api/seller/updateVisible',{id:obj.id,visible:checked})
		.then((r) => {
			M.toast({html:'Actualizado!'})
		})
		.catch(r=>alert(r))
	}

	/**
	  * añade stock
	  * @var formDataStockAdd obj {folio:'', item_no:'', quantity:'', note:''}
	  */
	const _addStock = () => {
		if (formDataStockAdd.folio === '' || formDataStockAdd.quantity === '' || formDataStockAdd.note === '') {
			alert('Incomplete data')
			return
		}
		const order_date = document.querySelector('#order-date').value                   // datepicker de Materialize, no controlado
		axios.post('/api/seller/add_stock', { ...formDataStockAdd, order_date, item_no: productoStockSelect.item_no ?? productoStockSelect.codigo })
		.then(r => {
			M.toast({ html: 'Updated!' })
			setFormDataStockAdd({ folio:'', item_no:'', quantity:'', note:'' })
			document.querySelector('#order-date').value = ''
			// suma optimista en la fila: un producto sin variantes tiene item_no null y la orden va con su codigo
			// (theme-001 compara solo item_no y no actualiza esas filas — bug pendiente allá)
			setCatalogo(catalogo.map(c => (c.item_no ?? c.codigo) === r.data.item_no ? { ...c, stock: c.stock + parseInt(r.data.quantity) } : c))
			setOrderHistory([...orderHistory, r.data])                                       // la pestaña de historial se actualiza sin refetch
		})
		.catch(r => alert(r))
	}

	return (
		<>
		<div id="add-stock" className="modal">
			<div className="modal-content">
				<h4>Add stock: {productoStockSelect.item_no ?? productoStockSelect.codigo}</h4>
				<div className="row">
					<form className="col s12">
						<div className="row">
							<div className="input-field col s12">
								<input id="order-date" type="text" className="datepicker" />
								<label htmlFor="order-date">Order date</label>
							</div>
							<div className="input-field col s12">
								<input id="folio" type="text" value={formDataStockAdd.folio} onChange={(e) => setFormDataStockAdd({ ...formDataStockAdd, folio: e.target.value })} />
								<label htmlFor="folio">Order folio</label>
							</div>
							<div className="input-field col s12">
								<input id="quantity" type="number" value={formDataStockAdd.quantity} onChange={(e) => setFormDataStockAdd({ ...formDataStockAdd, quantity: e.target.value })} />
								<label htmlFor="quantity">Quantity</label>
							</div>
							<div className="input-field col s12">
								<input id="note" type="text" value={formDataStockAdd.note} onChange={(e) => setFormDataStockAdd({ ...formDataStockAdd, note: e.target.value })} />
								<label htmlFor="note">Note</label>
							</div>
						</div>
					</form>
				</div>
			</div>
			<div className="modal-footer">
				<a href="#!" className="modal-close waves-effect waves-light btn-flat black white-text" style={{ marginRight: 20 }}>Close</a>
				<a href="#!" className="modal-close waves-effect waves-light btn-flat black white-text" onClick={() => _addStock()}>Save</a>
			</div>
		</div>

		<div style={{ marginTop: '50px', minWidth: 1080 }}>
			<Link to="/altaproducto" className="btn waves-effect waves-light right black" style={{display:'flex', alignItems:'center'}}><i className="material-icons">flash_on</i>New product</Link>
			<ul id="tabs-swipe-demo" className="tabs ul-tabs">
				<li className="tab col s2"><a className="active" href="#catalogo-tab">Catalog</a></li>
				<li className="tab col s2"><a href="#papelera-tab">Archived</a></li>
				<li className="tab col s3"><a href="#orders-history-tab">Orders history</a></li>
			</ul>
			<div id="catalogo-tab" className='card-panel'>
				<div className="row m-p-0">
				{!view &&
					<div className="col m12 m-p-0">
						<i className="small material-icons right" onClick={_changeView} style={{cursor:'pointer'}}>tock</i>
					</div>
				}
				{view &&
					<div className="col m12 m-p-0">
						<i className="small material-icons right" onClick={_changeView} style={{cursor:'pointer'}}>apps</i>
					</div>
				}
				</div>

				<h4>Catalog</h4>
				<nav>
					<div className="nav-wrapper">
						<form>
							<div className="input-field white row">
								<div className='col s1 m1' style={{margin:0, padding:0, textAlign:'center'}}>
									<label className="label-icon" htmlFor="search"><i className="material-icons" style={{color: 'black',}}>search</i></label>
								</div>
								<div className='col s10 m10' style={{margin:0, padding:0,}}>
									<input value={search} onChange={e=>setSearch(e.target.value)} id="search" type="search" required placeholder='Code, Category, Departament, Name'/>
								</div>
								<div className='col s1 m1' style={{margin:0, padding:0, textAlign:'center',}}> <i className="material-icons">close</i> </div>
							</div>
						</form>
					</div>
				</nav>
			{!view?
				<div className="row">
					<Paginacion pagina={page} totalPaginas={lastPage} onChange={(n) => _fetchCatalogo(n)} perPage={perPage} onPerPageChange={_changePerPage} />
					<table id="table-catalogo">
						<thead>
						<tr>
							<th>Picture</th>
							<th>Code</th>
							<th>Options</th>
							<th>Name</th>
							<th>Stock</th>
							<th>Visible</th>
							<th>Departament</th>
							<th>Category</th>
							<th>Description</th>
							<th>Variant</th>
							<th>Edit</th>
						</tr>
						</thead>

						<tbody>
						{catalogo.map(c=>
							<tr key={c.item_no ?? c.id}>
								<td style={{width:'100px'}}>
									<img alt='producto' src={c.imgs?.[0] ?? c.thumbnail ?? ImageNotAvailable} height='50' style={{marginLeft:'auto'}}/>
								</td>
								<td> {c.item_no??c.codigo} </td>
								<td>
									<a className="waves-effect waves-light btn modal-trigger black" href="#add-stock" onClick={() => setProductoStockSelect(c)}>Add stock</a>
								</td>
								<td> {c.nombre} </td>
								<td> {c.stock} </td>
								<td>
									<div className="switch">
										<label>
											<input type="checkbox" checked={c.visible} onChange={(e)=>_updateCatalogo(c,e.target.checked)}/>
											<span className="lever"></span>
										</label>
									</div>
								</td>
								<td> {c.departamento} </td>
								<td> {c.categoria} </td>
								<td> {c.descripcion} </td>
								<td> {c.attribute_type}: {c.attribute_value}</td>
								<td>
									<Link to={`/catalogo/producto/${c.id}`} className='black-text'>
										<i className="material-icons">edit</i>
									</Link>
								</td>
							</tr>
						)}
						</tbody>
					</table>
					<Paginacion pagina={page} totalPaginas={lastPage} onChange={(n) => _fetchCatalogo(n)} perPage={perPage} onPerPageChange={_changePerPage} />
				</div>
				:
				<div className="row">
					<Paginacion pagina={page} totalPaginas={lastPage} onChange={(n) => _fetchCatalogo(n)} perPage={perPage} onPerPageChange={_changePerPage} />
				{catalogo.map((c,i)=>
					<div key={i} className="col m6">
						<div className="card-panel" style={{position:'relative'}}>
							<Link to={`/catalogo/producto/${c.id}`} className='black-text' style={{position:'absolute', right:10, top:10}}>
								<i className="material-icons">edit</i>
							</Link>
						<div className='row'>
							<div className="col m5" id="slider2">
								<img alt='producto' src={c.imgs?.[0] ?? c.thumbnail ?? ImageNotAvailable} height='200' style={{marginLeft:'auto'}}/>
							</div>

							<div className="col m7">
								<div style={{height:200, overflowY:'auto'}}>
									<div className='black-text'>{c.item_no??c.codigo}</div>
									{c.attribute_value && (
										<div className='black-text'><b style={{fontWeight:'bold', fontSize:'12px'}}>Attribute:</b> {c.attribute_value}</div>
									)}
									<div className='black-text'><b style={{fontWeight:'bold', fontSize:'12px'}}>Name:</b> {c.nombre}</div>
									<div className='black-text'><b style={{fontWeight:'bold', fontSize:'12px'}}>Description:</b> {c.descripcion}</div>
									<div className='black-text'><b style={{fontWeight:'bold', fontSize:'12px'}}>Category:</b> {c.categoria}</div>
									<div className='black-text'><b style={{fontWeight:'bold', fontSize:'12px'}}>Departament:</b> {c.departamento}</div>
								</div>
							</div>
						</div>
						</div>
					</div>
				)}
					<Paginacion pagina={page} totalPaginas={lastPage} onChange={(n) => _fetchCatalogo(n)} perPage={perPage} onPerPageChange={_changePerPage} />
				</div>
			}
			</div>

			<div id="papelera-tab" className='card-panel'>
				<h4>Archived</h4>
				<nav>
					<div className="nav-wrapper">
						<form>
							<div className="input-field white">
								<input value={searchArchivados} onChange={e=>setSearchArchivados(e.target.value)} id="searchArch" type="search" required placeholder='Code, Category, Departament, Name'/>
								<label className="label-icon" htmlFor="searchArch"><i className="material-icons" style={{color: 'black'}}>search</i></label>
								<i className="material-icons">close</i>
							</div>
						</form>
					</div>
				</nav>
				<div className="row">
					<table id="table-catalogo">
						<thead>
						<tr>
							<th></th>
							<th style={{textAlign:"left"}}>Code</th>
							<th style={{textAlign:"left"}}>Name</th>
							<th style={{textAlign:"left"}}>Departament</th>
							<th style={{textAlign:"left"}}>Category</th>
							<th></th>
						</tr>
						</thead>

						<tbody>
						{papelera.filter(c=>c.nombre.toLowerCase().includes(searchArchivados.toLowerCase()) || c.codigo.includes(searchArchivados)||c.categoria.toLowerCase().includes(searchArchivados.toLowerCase()) || c.departamento.toLowerCase().includes(searchArchivados.toLowerCase())).slice(0,50).map((c,i)=>
							<tr key={i}>
								<td style={{width:'100px'}}>
									<img alt='producto' src={c.imgs?.[0] ?? c.thumbnail ?? ImageNotAvailable} height='50' style={{marginLeft:'auto'}}/>
								</td>
								<td> {c.item_no??c.codigo} </td>
								<td> {c.nombre} </td>
								<td> {c.departamento} </td>
								<td> {c.categoria} </td>
								<td>
									<div onClick={()=>_restaurar(c.id)} className='black-text pointer tooltipped' data-position="top" data-tooltip="Restaurar">
										<i className="material-icons">unarchive</i>
									</div>
								</td>
							</tr>
						)}
						</tbody>
					</table>
				</div>
			</div>

			<div id="orders-history-tab" className='card-panel'>
				<h4>Orders history</h4>
				<table>
					<thead>
					<tr>
						<th>Order folio</th>
						<th>Order date</th>
						<th>Code</th>
						<th>Quantity</th>
						<th>Note</th>
					</tr>
					</thead>

					<tbody>
					{orderHistory.map((order) =>
						<tr key={order.id}>
							<td>{order.folio}</td>
							<td>{order.order_date}</td>
							<td>{order.item_no}</td>
							<td>{order.quantity}</td>
							<td>{order.note}</td>
						</tr>
					)}
					</tbody>
				</table>
			</div>
		</div>
		</>
	)
}

export default Catalogo
